import AppButton from '@theme/components/atom/AppButton'
import LoadingMixin from '~/mixins/LoadingMixin'
import axios from 'axios'

export default {
  mixins: [LoadingMixin],
  components: {
    AppButton,
  },
  props: {
    tin: String,
    required: true,
  },
  methods: {
    async callAres() {
      if (await this.$validator.validate('tin')) {
        this.startLoading()
        const data = await this.$store.dispatch('user/LOAD_USER_FROM_ARES', {
          tin: this.tin,
        })
        await this.$emit('loaded', data)
        this.stopLoading()
      }
    },
  },
}
